/**
 * @file
 * Bandwango global configuration.
 *
 * Sets the window.bwvars object required by Bandwango's persistentCart.js
 * before that script initialises. This file is part of the
 * tnvacation/bandwango-embed library and is loaded only on pages that contain
 * a Bandwango Passport paragraph.
 */

window.bwvars = {
  offerId: 4186,
  partnerId: 482,
  checkoutUrl: 'https://explore.tnvacation.com'
};
